export const COLLECTION_NAME = "characters";

export { useFetchCharactersByIds } from "./fetchCharacters";
